module.exports = __webpack_public_path__ + "img/tiktok_navigation.17e3f512.png";